import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import './BrowserLockExitModal.css';

const BrowserLockExitModal = ({ open, onClose, onConfirm, loading = false }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle className="browser-lock-modal-title">
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Typography variant="h6">
            Session Exit Confirmation
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            <strong>Warning:</strong> You are about to exit your assessment session.
          </Typography>
        </Alert>
        
        <Typography variant="body1" paragraph>
          Your session will be ended and grades will be calculated up to this point. 
          This action cannot be undone.
        </Typography>
        
        <Typography variant="body2" color="textSecondary">
          Are you sure you want to exit the session?
        </Typography>
      </DialogContent>
      
      <DialogActions className="browser-lock-modal-actions">
        <Button 
          onClick={onClose} 
          variant="outlined"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="warning"
          disabled={loading}
        >
          {loading ? 'Ending Session...' : 'Exit Session'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BrowserLockExitModal; 